import {
    Button,
    Flex,
    Heading,
    Image,
    Stack,
    Text,
    useBreakpointValue,
} from '@chakra-ui/react';

import { FaRegArrowAltCircleRight } from 'react-icons/fa';
import './layouts.scss'
  
  export default function Split(props) {
    return (
      <Stack 
        minH={'100vh'}
        direction={{ base: 'column', md: 'row' }}
        className={props.className ? `split-layout ${props.className}` : 'split-layout'}
       >
        {props.leftImage ? (
            <Flex flex={1}>
              <a href={props.buttonUrl || '/' } className="image-link-wrap" >
                <Image
                  alt={props.imgAlt}
                  objectFit={props.imgFit || 'contain'}
                  src={props.img}
                  className='split-image'
                />
              </a>
            </Flex>
        ) : null }
        <Flex p={8} flex={1} align={'center'} justify={'center'}>
          <Stack spacing={6} w={'full'} maxW={'lg'} className="split-text">
            <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}>
              <Text
                as={'span'}
                position={'relative'}
                _after={{
                  content: "''",
                  width: 'full',
                  height: useBreakpointValue({ base: '20%', md: '30%' }),
                  position: 'absolute',
                  bottom: 1,
                  left: 0,
                  bg: 'brand.main',
                  zIndex: -1,
                }}>
                { props.title1 || 'Title1 Text' }
              </Text>
              <br />{' '}
              <Text color={'brand.main'} as={'span'}>
                { props.title2 || 'Title2 Text' }
              </Text>{' '}
            </Heading>
            <Text fontSize={{ base: 'md', lg: 'lg' }} color={'brand.black'}>
              { props.description || 'Description text'}
            </Text>
            <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
              <Button
                as={'a'}
                href={ props.buttonUrl || '/' }
                rightIcon={<FaRegArrowAltCircleRight />}
                rounded={'full'}
                bg={'brand.main'}
                color={'white'}
                _hover={{
                  bg: 'brand.dark',
                }}>
                { props.buttonText || 'Button Text'}
              </Button>
            </Stack>
          </Stack>
        </Flex>
        {!props.leftImage ? (
            <Flex flex={1}>
              <a href={props.buttonUrl || '/' } className="image-link-wrap">
                <Image
                  alt={props.imgAlt}
                  objectFit={props.imgFit || 'contain'}
                  src={props.img}
                  className='split-image'
                />
              </a>
            </Flex>
        ) : null }
      </Stack>
    );
  }